import React, { useState } from "react";
import Logo from "../../assets/LoanPage/Naayatrade_Final_Logo_File.png";
import Cover from "../../assets/LoanPage/Cover.png";
import rectangle from "../../assets/LoanPage/rectangle.png";
import { Slider } from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomSlider = styled(Slider)({
  color: "#FF6300", // Red color for the active part of the slider
  "& .MuiSlider-thumb": {
    backgroundColor: "#FF6300", // Red color for the thumb
  },
  "& .MuiSlider-track": {
    backgroundColor: "#FF6300", // Red color for the track
  },
  "& .MuiSlider-rail": {
    backgroundColor: "#808080", // Grey color for the rail
  },
});

const GetLoan = () => {
  const [amount, setAmount] = useState([50000]); // Amount range
  const [duration, setDuration] = useState([12]); // Duration range
  const [rate, setRate] = useState([10]); // Interest rate
  const [emi, setEmi] = useState(0);

  const handleAmountChange = (event, newValue) => {
    setAmount(newValue);
  };

  const handleDurationChange = (event, newValue) => {
    setDuration(newValue);
  };

  const handleRateChange = (event, newValue) => {
    setRate(newValue);
  };

  const handleCalculate = () => {
    const principal = parseInt(amount[0]);
    const interestRate = parseInt(rate[0]);
    const term = parseInt(duration[0]);
    const emiValue = calculateEMI(principal, interestRate, term);
  
    setEmi(emiValue.toFixed(2));
  };
  
  const calculateEMI = (principal, annualRate, months) => {
    // [P x R x (1+R)^N] / [(1+R)^N-1]
    const monthlyRate = annualRate / 12 / 100; // Convert annual rate to monthly and percentage to decimal
  
    // EMI formula
    const emi = (principal * monthlyRate * Math.pow(1 + monthlyRate, months)) /
                (Math.pow(1 + monthlyRate, months) - 1);
  
    return emi;
  };  

  const cardData = [
    {
      id: 1,
      title: "Complete the Application",
      description:
        "The borrower fills out the loan application. Soon, our representative will reach out to you.",
      image: rectangle,
    },
    {
      id: 2,
      title: "Upload Documents",
      description:
        "Submit the necessary documentation to verify your identity and eligibility for further procedures.",
      image: rectangle,
    },
    {
      id: 3,
      title: "Get Funds",
      description:
        "After verification of your documents, the money will be transferred to your preferred account.",
      image: rectangle,
    },
  ];

  const services = [
    {
      title: "Competitive interest rates",
      detail:
        "offer competitive interest rates compared to traditional banks or financial institutions.",
      img: require("../../assets/LoanPage/trade.png"),
      bgColor: "bg-[#FFE6CD]",
    },
    {
      title: "Flexible loan term",
      detail:
        "Borrowers may have access to flexible repayment schedules to their business needs.",
      img: require("../../assets/LoanPage/trade.png"),
      bgColor: "bg-[#FFF4DA]",
    },
    {
      title: "Speed and convenience",
      detail:
        "using technology to  credit assessments This can lead to quicker access to funds .",
      img: require("../../assets/LoanPage/trade.png"),
      bgColor: "bg-[#DFFFD1]",
    },
    {
      title: "Support for specific needs",
      detail:
        " loans can be structured to meet specific business needs, such as funding for inventory, equipment .",
      img: require("../../assets/LoanPage/trade.png"),
      bgColor: "bg-[#D8F3FF]",
    },
  ];

  return (
    <>
      {/* first section */}
      <div
        className="w-full h-screen bg-cover bg-center"
        style={{ backgroundImage: `url(${Cover})` }}
      >
        <div className="flex w-[1240px] m-auto flex-row items-center justify-between p-8 gap-9">
          {/* left side */}
          <div className="w-[719px] h-[218px] flex flex-col">
            <img src={Logo} alt="" className="w-[91px] h-[112px]" />
            <p className="w-[360px] h-[54px] text-[#FF6300] font-bold text-[36px] mt-[26px]">
              Need <span className="text-[#FF6300]">Instant Loan?</span>
            </p>
            <p className="w-[719px] h-[102px] text-white font-medium text-[20px] mt-[13px]">
              Our loan services offer a hassle-free and streamlined borrowing
              experience, providing you with the funds you need in a timely
              manner to meet your financial requirements.
            </p>
          </div>

          {/* right side */}
          <div className="w-[456px] h-[595px] bg-white shadow-md rounded-xl p-4">
            <div className="w-full text-[#FF6300] font-semibold text-[16px] text-center mb-4">
              Loan EMI Calculator
            </div>
            <div className="flex flex-col">
              <div>
                <p className="w-[58px] h-[21px] text-[#808080] mt-6 font-semibold">
                  Amount
                </p>
                <p className="w-[157px] h-[37px] bg-[#F2F2F2] rounded-md font-semibold text-black flex p-2 mt-2">
                  ₹ {amount[0].toLocaleString()}
                </p>
              </div>
              <div className="w-[369px]">
                <CustomSlider
                  value={amount}
                  onChange={handleAmountChange}
                  valueLabelDisplay="auto"
                  min={50000}
                  max={500000}
                  step={1000}
                  className="w-[242px]"
                />
              </div>
              <div className="flex justify-between font-semibold">
                <p>₹ 50,000</p>
                <p>₹ 500,000</p>
              </div>
            </div>
            <div className="flex flex-col mt-4">
              <div>
                <p className="w-[58px] h-[21px] text-[#808080] font-semibold">
                  Duration
                </p>
                <p className="w-[157px] h-[37px] bg-[#F2F2F2] rounded-md font-semibold text-black flex p-2 mt-2">
                  {duration[0].toLocaleString()} Months
                </p>
              </div>
              <div className="w-[369px]">
                <CustomSlider
                  value={duration}
                  onChange={handleDurationChange}
                  valueLabelDisplay="auto"
                  min={12}
                  max={72}
                  step={1}
                  className="w-[242px]"
                />
              </div>
              <div className="flex justify-between font-semibold">
                <p>12 months</p>
                <p>72 months</p>
              </div>
            </div>
            <div className="flex flex-col mt-4">
              <div>
                <p className="w-[160px] h-[21px] text-[#808080] font-semibold">
                  Rate Of Interest
                </p>
                <p className="w-[157px] h-[37px] bg-[#F2F2F2] rounded-md font-semibold text-black flex p-2 mt-2">
                  {rate[0]} %
                </p>
              </div>
              <div className="w-[369px]">
                <CustomSlider
                  value={rate}
                  onChange={handleRateChange}
                  valueLabelDisplay="auto"
                  min={0}
                  max={20}
                  step={0.1}
                  className="w-[242px]"
                />
              </div>
              <div className="flex justify-between">
                <p>0 %</p>
                <p>20 %</p>
              </div>
            </div>
            <div className="bg-[#F96D24] rounded-md flex items-center justify-center mt-4">
              <button
                onClick={handleCalculate}
                className="text-white text-center text-sm py-3 px-4 w-full"
              >
                Calculate EMI
              </button>
            </div>
            <div className="text-center mt-4">
              {emi > 0 && (
                <p className="text-[#FF6300] font-semibold text-lg">
                  Your EMI: ₹ {emi}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* second section */}
      <div className="w-[1240px] m-auto pt-9 h-[318px] bg-white shadow-lg rounded-lg relative -mt-16 z-10">
        {/* Content for the second section */}
        <p className="w-[153px] h-[36px] font-semibold text-[#FF6300] ml-4 text-[20px]">
          Personal Detail
        </p>
        <div className="flex gap-6 ml-4">
          <div className="flex flex-col">
            <label className="block w-[118px] h-[21px] font-semibold text-[14px] text-[#808080]">
              Company Name
            </label>
            <input
              type="text"
              className="block w-[335px] h-[42px] rounded-[5px] p-[12px] text-[12px] font-medium border mt-[11px]"
            />
          </div>
          <div className="flex flex-col">
            <label className="block w-[160px] h-[21px] font-semibold text-[14px] text-[#808080]">
              Number of Months
            </label>
            <input
              type="text"
              className="block w-[335px] h-[42px] rounded-[5px] p-[12px] text-[12px] font-medium border mt-[11px]"
            />
          </div>
          <div className="flex flex-col">
            <label className="block w-[118px] h-[21px] font-semibold text-[14px] text-[#808080]">
              Email ID
            </label>
            <input
              type="text"
              className="block w-[335px] h-[42px] rounded-[5px] p-[12px] text-[12px] font-medium border mt-[11px]"
            />
          </div>
        </div>
        <div className="w-[1240px] h-[200px] flex items-center justify-center">
          <button className="bg-[#F96D24] text-white w-[185px] h-[44px] text-[16px] rounded-md shadow-md">
            Apply for Loan
          </button>
        </div>
      </div>

      {/* third section */}
      <div className="w-[1240px] m-auto">
        <p className="w-[190px] h-[36px] font-semibold text-[#FF6300] mt-4">
          How does it Work?
        </p>
        <div className="flex gap-14">
          {cardData.map((card) => (
            <div
              key={card.id}
              className="w-[374px] h-[346px] bg-white shadow-md rounded-md"
            >
              <img
                src={card.image}
                alt=""
                className="w-[378px] h-[208px] p-5"
              />
              <p className="text-[#F96D24] ml-5 w-[325px] h-[28px] font-semibold">
                {card.id} <span className="text-black">: {card.title}</span>
              </p>
              <p className="w-[347px] h-[59px] font-normal text-[16px] ml-3 mt-4">
                {card.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* fourth section */}
      <div className="w-[1240px] m-auto">
        <p className="w-[190px] h-[36px] font-semibold text-[#FF6300] mt-4">
          Loan : Benefits
        </p>
        <div className="flex flex-wrap justify-center gap-x-[44px] gap-y-8 mt-9 w-[1240px] h-[330px] m-auto">
          {services.map((item) => (
            <div className="flex flex-col items-center justify-between relative w-[273px] h-[285px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)] bg-white rounded-xl select-none">
              <div className="px-6 flex flex-col items-center">
                <div
                  className={`${item.bgColor} absolute top-[-38px] left-[32%] p-3 rounded-full`}
                >
                  <img className="h-[65px]" src={item.img} alt="img2" />
                </div>
                <h4 className="mt-20 w-[240px] h-[28px] text-[18px] font-semibold leading-[28px] text-center font-poppins">
                  {item.title}
                </h4>
                <p className="text-[16px] font-medium leading-[30px] text-center font-poppins text-[#979797] mt-4">
                  {item.detail}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default GetLoan;
